import dashboardIcon from '@assets/icons/dashboard.svg';
import dashboardActive from '@assets/icons/dashboard-active.svg';

import usersIcon from '@assets/icons/users.svg';
import usersIconActive from '@assets/icons/users-active.svg';

import { LiaStickyNoteSolid } from 'react-icons/lia';
import { FaBowlFood } from 'react-icons/fa6';
import { IoMdSettings } from 'react-icons/io';
import { GiSpoon } from 'react-icons/gi';
import { GiHotMeal } from 'react-icons/gi';
import { IoPricetags } from 'react-icons/io5';

import {
  DASHBOARDHOME,
  CUSTOMERS,
  SETTINGS,
  MEALS,
  PRODUCT_GROUPS,
  FACTS,
  MEAL_TAGS,
  RECIPE_COLLECTION,
  INGREDIENTS_LIST,
  RECIPE_GROUPS,
  BLOGS,
  STAFF
} from '@app/pages/ROUTECONSTS';
import DashboardIcon from '@app/assets/svgs/dashboard-icon';
import CustomersIcon from '@app/assets/svgs/customers-icon';
import MealsIcon from '@app/assets/svgs/meals-icon';
import IngredientsIcon from '@app/assets/svgs/ingredients-icon';
import MealTagsIcon from '@app/assets/svgs/mealtags-icon';
import LuFactsIcon from '@app/assets/svgs/lu-facts-icon';
import SettingsIcon from '@app/assets/svgs/settings-icon';
import { Barrel, CookingPot, Library, UserCog } from 'lucide-react';

export const navData = [
  {
    title: 'Overview',
    routes: [
      {
        name: 'Dashboard',
        link: DASHBOARDHOME,
        icon: <DashboardIcon />,
        iconActive: <DashboardIcon color="#fff" />
      },
      {
        name: 'Customers',
        link: CUSTOMERS,
        icon: <CustomersIcon />,
        iconActive: <CustomersIcon color="#fff" />
      },
      {
        name: 'Staff',
        link: STAFF,
        icon: <UserCog color="#FFFFFF8C" size={16} />,
        iconActive: <UserCog color="#fff" size={16} />
      }
    ]
  },
  {
    title: 'Content',
    routes: [
      {
        name: 'Meals',
        link: MEALS,
        icon: <MealsIcon />,
        iconActive: <MealsIcon color="#fff" />
      },
      {
        name: 'Recipes',
        link: RECIPE_COLLECTION,
        icon: <CookingPot color="#FFFFFF8C" size={16} />,
        iconActive: <CookingPot color="#fff" size={16} />
      },
      {
        name: 'Recipe Groups',
        link: RECIPE_GROUPS,
        icon: <Barrel color="#FFFFFF8C" size={16} />,
        iconActive: <Barrel color="#fff" size={16} />
      },
      {
        name: 'Ingredients',
        link: INGREDIENTS_LIST,
        icon: <IngredientsIcon />,
        iconActive: <IngredientsIcon color="#fff" />
      },
      {
        name: 'Blogs',
        link: BLOGS,
        icon: <Library color="#FFFFFF8C" size={16} />,
        iconActive: <Library color="#fff" size={16} />
      }
    ]
  },
  {
    title: 'Management',
    routes: [
      {
        name: 'Meals Tags',
        link: MEAL_TAGS,
        icon: <MealTagsIcon />,
        iconActive: <MealTagsIcon color="#fff" />
      },
      {
        name: 'Product Groups',
        link: PRODUCT_GROUPS,
        icon: <IngredientsIcon />,
        iconActive: <IngredientsIcon color="#fff" />
      },
      {
        name: 'LU Facts',
        link: FACTS,
        icon: <LuFactsIcon />,
        iconActive: <LuFactsIcon color="#fff" />
      },
      {
        name: 'Settings',
        link: SETTINGS,
        icon: <SettingsIcon />,
        iconActive: <SettingsIcon color="#fff" />
      }
    ]
  }
];

export const menuData = [
  {
    icon: dashboardIcon,
    activeIcon: dashboardActive,
    text: 'Dashboard',
    isActive: false,
    link: DASHBOARDHOME
  },
  {
    icon: usersIcon,
    activeIcon: usersIconActive,
    text: 'Customers',
    isActive: false,
    link: CUSTOMERS
  },
  {
    icon: <GiHotMeal size="25" color="#828282" />,
    activeIcon: <GiHotMeal size="25" color="#fff" />,
    text: 'Meals',
    isActive: false,
    link: MEALS
  },
  {
    icon: <FaBowlFood size="20" color="#828282" />,
    activeIcon: <FaBowlFood size="20" color="#fff" />,
    text: 'Recipes',
    isActive: false,
    link: RECIPE_COLLECTION
  },
  {
    icon: <FaBowlFood size="20" color="#828282" />,
    activeIcon: <FaBowlFood size="20" color="#fff" />,
    text: 'Recipe Groups',
    isActive: false,
    link: RECIPE_GROUPS
  },
  {
    icon: <GiSpoon size="25" color="#828282" />,
    activeIcon: <GiSpoon size="25" color="#fff" />,
    text: 'Ingredients',
    isActive: false,
    link: INGREDIENTS_LIST
  },
  {
    icon: <IoPricetags size="20" color="#828282" />,
    activeIcon: <IoPricetags size="20" color="#fff" />,
    text: 'Meals Tags',
    isActive: false,
    link: MEAL_TAGS
  },
  {
    icon: usersIcon,
    activeIcon: usersIconActive,
    text: 'Product Groups',
    isActive: false,
    link: PRODUCT_GROUPS
  },
  {
    icon: <LiaStickyNoteSolid size="25" color="#828282" />,
    activeIcon: <LiaStickyNoteSolid size="25" color="#fff" />,
    text: 'LU Facts',
    isActive: false,
    link: FACTS
  },
  {
    icon: <IoMdSettings size="25" color="#828282" />,
    activeIcon: <IoMdSettings size="25" color="#fff" />,
    text: 'Settings',
    isActive: false,
    link: SETTINGS
  }
];
